import { ModulesCard } from "./ModulesCard";
import { ModuleEdit } from "./module-edit/ModuleEdit";

export function ModulesPage() {
  return (
    <div className="row">
      <div className="col-4">
        <ModulesCard />
      </div>

      <div className="col-8">
        <ModuleEdit />
      </div>
    </div>    
  );
}